<template>
  <div>
    <div class="base_head_title">
      <img src="../../../static/img/home/y_title.png" alt="">
      <span v-for="(item,index) in title_arr"
            style="cursor: pointer"
            :class="{
              right_border:title_arr.length > 1 && (index !== title_arr.length - 1),
              change_click:current_index === index
            }"
            @click="clickTitle(item,index)"
      >
        {{ item }}
      </span>
      <div style="display: inline-block;float: right;cursor: pointer;" class="more_hover" @click="moreClick">
        <span style="font-size: 12px;color: #999;font-weight: 400;vertical-align: middle;" v-if="more">
          查看更多
        </span>
        <img src="../../../static/img/home/more.png" alt=""
             style="width: 12px;height: 12px;vertical-align: middle;margin: 0"
             v-if="more"
             class="more_hover_img1"
        >
        <img src="../../../static/img/home/more2.png" alt=""
             style="width: 12px;height: 12px;vertical-align: middle;margin: 0"
             v-if="more"
             class="more_hover_img2"
        >
      </div>
      <div style="color: #333;margin-top: 10px;"
           v-for="(item,index) in content_arr"
           v-if="index === current_index"
           @click="clickTitle(item,index)"
      >
        <div class="ul_c flex_display_between" style="flex-wrap: wrap">
          <div class="flex_display_between li_hover"
               v-for="(it,ind) in item"
               :style="{
                  width:100 / columns + '%',
                  paddingRight: columns > 1 && (ind % 2 ===0) ?'20px' : '',
                  paddingLeft: columns > 1 && (ind % 2 !==0) ?'20px' : ''
                }"
          >
            <div class="dot_k" v-if="it.title">
              <span class="dot"></span>
            </div>
            <span class="title base_ellipsis" v-if="it.title" @click="clickText(it)" style="cursor: pointer">{{ it.title }}</span>
            <span class="time" v-if="it.title">[{{ it.createTime }}]</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ChangeTitle",
  props: {
    title_arr: [],
    content_arr: {
      type: Array,
      default: () => []
    },
    columns: {
      type: Number,
      default: 1
    },
    more: {
      type: Boolean,
      default: true
    },
    goRoute: '',
    code: '',
    goRouteDetails: '',
  },
  data() {
    return {
      current_index: 0
    }
  },
  methods: {
    clickTitle(item, index) {
      this.current_index = index;
      this.$emit('titleClick',item)
    },
    moreClick() {
      this.$router.push({
        path: this.goRoute,
        query: {
          code: this.code
        }
      })
    },
    clickText(item) {
      this.$emit('textClick',item)
      this.$router.push({
        path: item.path,
        query: {
          id: item.id
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.base_head_title {
  font-size: 16px;
  color: #999999;
  font-weight: 700;

  img {
    width: 6px;
    height: 18px;
    vertical-align: middle;
    margin-right: 5px;
  }

  span {
    vertical-align: middle;
  }
}

.base_ellipsis {
  text-overflow: -o-ellipsis-lastline;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  line-clamp: 1;
  -webkit-box-orient: vertical;
}

.flex_display_between {
  display: flex;
  justify-content: space-between;
}

.right_border {
  border-right: 1px solid #D8D8D8;
  margin-right: 10px;
  padding-right: 5px;
}

.change_click {
  color: #333;
}

.ul_c {
  font-weight: 400;
}

.dot_k {
  display: inline-block;
  height: 34px;
  width: 4px;
  line-height: 31px;
  padding-right: 10px;
}

.dot {
  display: inline-block;
  width: 4px;
  height: 4px;
  border-radius: 50%;
  background-color: #CCCCCC;
}

.title {
  font-size: 14px;
  flex: 1;
  height: 34px;
  line-height: 34px;
}

.time {
  width: 42px;
  height: 34px;
  line-height: 34px;
  float: right;
  color: #999;
  font-size: 12px;
}

.more_hover_img1 {
  display: inline-block;
}

.more_hover_img2 {
  display: none;
}

.more_hover:hover {
  span {
    color: #333 !important;
  }

  .more_hover_img1 {
    display: none;
  }

  .more_hover_img2 {
    display: inline-block;
  }
}

.li_hover:hover .title {
  color: #61A842;
  text-decoration: underline;
}
</style>



// WEBPACK FOOTER //
// src/components/hm_personal/ChangeTitle.vue